import {
  UserCollectionMap,
  ClientCollectionRow,
  getLatestReadStatus,
  calcOwnedVolumes,
  calcReadVolumes,
  calcReleasedVolumes,
  isEntryStatusComplete,
} from '.'
import { getMonth, getYear } from '@/utils'

export function extractCollectionMap(collections: ClientCollectionRow[]): UserCollectionMap {
  const map: UserCollectionMap = {}

  collections.forEach((c) => {
    const latestRead = getLatestReadStatus(c)
    const sortedVolumeVersions = c.entry?.sortedVolumeNumbers || []
    if (!c.entry?.id || !c.entry?.status) {
      console.error("Entry doesn't have attributes id or status", c)
      return
    }

    map[c.entry.id] = {
      clientId: c.clientId,
      id: c.id,
      entryId: c.entry.id,
      entryCompleted: isEntryStatusComplete(c.entry.status),
      startYear: getYear(c.entry.startDate),
      startMonth: getMonth(c.entry.startDate),
      endYear: getYear(c.entry.endDate),
      endMonth: getMonth(c.entry.endDate),
      collectionStartDate: c.startDate ?? null,
      collectionEndDate: c.endDate ?? null,
      collectionStatus: c.collectionStatus!,
      currentReadStatus: c.currentReadStatus!,
      sortedVolumeVersions,
      notReleasedVolumeNumbers: c.entry?.notReleasedVolumeNumbers ?? [],
      ownedVolumes: calcOwnedVolumes({ sortedVolumeVersions, ownedMap: { ...c.itemStatus } }),
      releasedVolumes: calcReleasedVolumes({
        sortedVolumeVersions,
        notReleasedVolumeNumbers: c.entry?.notReleasedVolumeNumbers ?? [],
      }),
      ownedMap: { ...c.itemStatus },
      miscOwnedMap: { ...c.miscItemStatus },
      readVolumes: latestRead
        ? calcReadVolumes({ sortedVolumeVersions, latestReadMap: { ...latestRead.readStatus } })
        : 0,
      latestReadId: latestRead?.id || null,
      latestReadMap: latestRead?.readStatus ? { ...latestRead.readStatus } : {},
    }
  })
  return map
}
